import languages from "./languages";

const lang = {
  message: {
    hello: "こんにちは、世界",
  },
  aboutNounsLove: "Nouns Loveについて",
  installMetaMask: "メタマスクをインストール",
  acceptingBits: "現在販売中",
  currentPrice: "現在の価格",
  getNoun: "Nounish NFTをゲット",
  heldBy: "オーナー: ",
  winningPrice: "落札価格:",
  sorryLowPrice: "誰かが落札したか、入札価格が低いです。",
  sorryLowGasPrice: "ガス代が不足しているため、処理に失敗しました。",
  invalidNetwork: "間違ったネットワークに接続しています",
  youNeetNet: "{networdName}に切り替えてください",
  notFoundMessage: "404: 探しているものはなんですか？見つけにくいものですか？",
  languages,
};

export default lang;
